import { POST_MESSAGE_EVENTS } from "src/constants/common";
import { STORAGE_KEYS } from "src/constants/common";
import analytics from "./analytics";
import sendMessageToParent from "./parentMessageHandler";
import storage from "./storage";
import { monitoring } from "src/monitoring";

const auth = {
  handleLogout: async () => {
    monitoring.setUser(null);

    await analytics.logout();
    storage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
    storage.removeAll();
    sendMessageToParent(POST_MESSAGE_EVENTS.LOGOUT);
  },
};

export default auth;
